import React from 'react';
import { isBrowser } from 'react-device-detect';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import LuckyDaysLogo from '../../UI/Logos/LuckyDaysLogo';
import { useAbsoluteNavigate } from '@/hooks/useAbsoluteNavigate';
import { closeAllModals, openModal } from '@/store/actions/modal';
import { openDrawer } from '@/store/actions/drawer';
import ModalLayout from '@/components/Modals/ModalLayout';
import { Button } from '@/components/buttons/Button';

function FailedLoginModal({ closeModal }: { closeModal: () => void }) {
  const dispatch = useDispatch();
  const navigate = useAbsoluteNavigate();
  const intl = useIntl();

  function helpClickHandler() {
    closeModal();

    if (isBrowser) {
      setTimeout(() => {
        dispatch(openDrawer('help'));
      }, 200);
    } else {
      navigate('/help');
    }
  }

  const onForgotPasswordClicked = () => {
    dispatch(closeAllModals([]));
    navigate('/forgot-password');
  };

  const onLoginAgainClicked = () => {
    dispatch(openModal('login'));
  };

  return (
    <ModalLayout closeModal={closeModal}>
      <div className="grid grid-cols-1 gap-6 justify-items-center">
        <LuckyDaysLogo />
        <div className="text-center">{intl.formatMessage({ id: 'failedLogin.text' })}</div>
        <div className="grid grid-cols-1 gap-4 justify-self-stretch">
          <Button
            type="button"
            onClickHandler={onForgotPasswordClicked}
            text={intl.formatMessage({ id: 'failedLogin.text.resetPassword' })}
          />
          <Button
            type="button"
            onClickHandler={helpClickHandler}
            text={intl.formatMessage({ id: 'failedLogin.text.contactSupport' })}
          />
          <Button
            type="button"
            onClickHandler={onLoginAgainClicked}
            text={intl.formatMessage({ id: 'failedLogin.text.tryAgain' })}
          />
        </div>
      </div>
    </ModalLayout>
  );
}

export default FailedLoginModal;
